import { IDeleteAllDocumentosUseCase } from "../../../presentation/useCases/delete/delete_all_documentos_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteAllDocumentosUseCase
 */

export class DeleteAllDocumentosUseCase implements IDeleteAllDocumentosUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteAllDocumentos(idFuncionario: number): Promise<void> {
    await this.repository.deleteAllDocumentos(idFuncionario);
  }
}